import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { toggleSessionExpired } from "../utils/uiSlice";

export declare interface CategorieState {
  [index: string]: any;
}

export interface Categorie {
  [index: string]: any;
  libelle: string;
  referenceFichier?: string;
}

const initialState: CategorieState = {};

export const categorieSlice = createSlice({
  initialState,
  name: "categorie",
  reducers: {
    createCategorie: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listCategorie: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeCategorie: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateCategorie: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createCategorie,
  listCategorie,
  removeCategorie,
  updateCategorie,
} = categorieSlice.actions;

export const createAsyncCategorie =
  (data: Categorie, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}categorie/admin-all`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 201) {
        dispatch(listAsyncCategorie());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create categorie error", error);
      onError?.();
    }
  };

export const updateAsyncCategorie =
  (data: Categorie, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}categorie/admin-all/${data.id}`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if ([201,200].includes(result.status)) {
        dispatch(listAsyncCategorie());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("sign in error", error);
      onError?.();
    }
  };

export const listAsyncCategorie =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(`${SERVER_URL}categorie`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();

      if (res?.length) {
        dispatch(listCategorie(res));
      }
    } catch (error) {
      console.log("list categorie error", error);
    }
  };

export default categorieSlice.reducer as Reducer<CategorieState>;
